import { apiService } from './apiWrapper';

/////////POST REQUESTS///////////

export const SOCIAL_LOGIN = (body) => {
  return apiService('auth/social-login', 'POST', body);
};
export const SIGNIN = (body) => {
  return apiService('auth/login', 'POST', { ...body });
};
export const ADD_USER = (body) => {
  return apiService('user', 'POST', body);
};
export const JOIN_USER = (body) => {
  return apiService('auth/join', 'POST', body);
};
export const SIGN_UP = (body) => {
  return apiService('auth/sign-up', 'POST', body);
};
export const VERIFY_OTP_LOGIN = (body) => {
  return apiService('auth/verify-otp', 'POST', body);
};
export const VERIFY_OTP_SIGNUP = (body) => {
  return apiService('auth/verify-otp', 'POST', body);
};
export const VERIFY_OTP_JOIN = (body) => {
  return apiService('auth/verify-otp', 'POST', body);
};
export const VERIFY_EMAIL = (body) => {
  return apiService('auth/forgot-password', 'POST', body);
};
export const RESET_PASSWORD = (body) => {
  return apiService('auth/reset-password', 'POST', body);
};
export const USER_RESET_PASSWORD = (body) => {
  return apiService('user/reset-password', 'POST', body);
};
export const CREATE_ORDER = (body) => {
  return apiService('order', 'POST', body);
};
export const CREATE_INVENTORY_ITEM = (body) => {
  return apiService('inventory', 'POST', body);
};
export const ADD_BANK = (body) => {
  return apiService('bank', 'POST', body);
};
export const REQUEST_DELETE_ACCOUNT = (body) => {
  return apiService('auth/request-delete-otp', 'POST', body);
};

/////////GET REQUESTS///////////
export const AUTH_ME = () => {
  return apiService('user/auth-me', 'GET');
};
export const GET_USER = (params) => {
  return apiService(`user?${params}`, 'GET');
};
export const GET_USER_BY_ID = (id) => {
  return apiService(`user/${id}`, 'GET');
};
export const GET_ALL_SUBORDER = (params) => {
  return apiService(`sub-order?${params}`, 'GET');
};
export const GET_ORDER = (params) => {
  return apiService(`order?${params}`, 'GET');
};
export const GET_ORDER_BY_ID = (id) => {
  return apiService(`order/${id}`, 'GET');
};
export const GET_ORDER_REPORT = (params) => {
  return apiService(`order/report/${params}`, 'GET');
};
export const GET_SUBORDER = (id) => {
  return apiService(`sub-order/${id}`);
};
export const GET_NOTIFICATIONS = (params, id) => {
  return apiService(`notification?pageSize=3&page=${params}&userId=${id}`, 'GET');
};
export const GET_INVENTORY = (params) => {
  return apiService(`inventory?${params}`, 'GET');
};
export const GET_INVENTORY_BY_DATE = (params) => {
  return apiService(`inventory/date?date=${params}`, 'GET');
};
export const GET_SETTING = () => {
  return apiService('setting', 'GET');
};
export const GET_REVENUE = () => {
  return apiService('order/revenue', 'GET');
};
export const GET_DASHBOARD_SUBORDERS = () => {
  return apiService('sub-order/dashboard-count', 'GET');
};
export const GET_DASHBOARD_COUNT = () => {
  return apiService('order/dashboard-count', 'GET');
};
// export const GET_AWAITING_PAYMENTS = () => {
//   return apiService('order/awaiting-payment/NEGOTIATION_SUCCESSFUL', 'GET');
// };
export const GET_TOP_CUSTOMERS = () => {
  return apiService('user/dashboard-count', 'GET');
};
export const GET_REVENUE_CHART_DATA = (mode, from, to) => {
  return apiService(`order/daily-revenue?mode=${mode}&from=${to}&to=${from}`);
};
export const GET_ALL_BANKS = (params) => {
  return apiService(`bank?${params}`, 'GET');
};
/////////PUT REQUESTS///////////
export const UPDATE_USER = (id, body) => {
  return apiService(`user/${id}`, 'PUT', body);
};
export const UPDATE_ORDER = (id, body) => {
  return apiService(`order/${id}`, 'PUT', body);
};
export const UPDATE_SUBORDER = (id, body) => {
  return apiService(`sub-order/${id}`, 'PUT', body);
};
export const UPDATE_INVENTORY_ITEM = (id, body) => {
  return apiService(`inventory/${id}`, 'PUT', body);
};
export const UPDATE_SETTING = (id, body) => {
  return apiService(`setting/${id}`, 'PUT', body);
};
export const UPDATE_BANK = (id, body) => {
  return apiService(`bank/${id}`, 'PUT', body);
};

/////////DELETE REQUESTS///////////
export const DELETE_USER = (id) => {
  return apiService(`user/${id}`, 'DELETE');
};
export const DELETE_ORDER = (id) => {
  return apiService(`order/${id}`, 'DELETE');
};
export const DELETE_SUBORDER = (id) => {
  return apiService(`sub-order/${id}`, 'DELETE');
};
export const DELETE_INVENTORY_ITEM = (id) => {
  return apiService(`inventory/${id}`, 'DELETE');
};
export const DELETE_NOTIFICATION_TOKEN = (body) => {
  return apiService(`user/logout`, 'PUT', body);
};
export const DELETE_BANK = (id) => {
  return apiService(`bank/${id}`, 'DELETE');
};
